export const state = () => ({
  openedModal: false,
  preloader: true,
  logInModal: null,
  registerModal: null,
  resetModal: null
})

export const getters = {
  openedModal: state => state.openedModal,
  preloader: state => state.preloader,
  logInModal: state => state.logInModal,
  registerModal: state => state.registerModal,
  resetModal: state => state.resetModal
}

/**
 * TODO: Refactor common mutations into high order fn
 */

export const mutations = {
  TOGGLE_MODAL(state, openedModal) {
    state.openedModal = openedModal
  },
  TOGGLE_PRELOADER(state, preloader) {
    state.preloader = preloader
  },
  SET_LOGIN(state, modal) {
    state.logInModal = modal
  },
  SET_REGISTER(state, modal) {
    state.registerModal = modal
  },
  SET_RESET(state, modal) {
    state.resetModal = modal
  }
}



// WEBPACK FOOTER //
// ./store/common.js